import { of, Observable } from 'rxjs';
import { UsersApiService } from '@/app/features/users';

import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UserResolver implements Resolve<any> {
  constructor(private userApiService: UsersApiService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const userId = route.params['userId'] as number;

    if (!userId) {
      return of(undefined);
    }

    return this.userApiService.loadUser(userId as number);
  }
}
